module.exports = __webpack_public_path__ + "static/media/Off the Cuff With Clerks Video_1632796200757.ce9e07ed.vtt";